import { render, staticRenderFns } from "./MobileFabulousComponent.vue?vue&type=template&id=7e622a72&lang=pug&"
var script = {}
import style0 from "./MobileFabulousComponent.vue?vue&type=style&index=0&id=7e622a72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports